module.exports = __webpack_public_path__ + "static/media/all_icon_color.3c00bd97.svg";